module.exports = __webpack_public_path__ + "img/official_account_qr_code.004cd2ec.jpeg";